import { render, staticRenderFns } from "./ProfilePurchases.vue?vue&type=template&id=4bab3296&scoped=true"
import script from "./ProfilePurchases.vue?vue&type=script&lang=ts"
export * from "./ProfilePurchases.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePurchases.vue?vue&type=style&index=0&id=4bab3296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab3296",
  null
  
)

export default component.exports